import { useReveal } from "@/hooks/useReveal";

const MARKETS = [
  { country: "Germany", line: "organic retail and distribution" },
  { country: "Australia", line: "traceability and social-impact buyers" },
  { country: "Chile", line: "full private label range developed for a distributor" },
  { country: "Romania", line: "organic distribution" },
];

export default function Markets() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section className="bg-white py-16 md:py-20">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Where we already ship
          </h2>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {MARKETS.map((market) => (
              <div
                key={market.country}
                className="rounded-lg border border-cream-dark/70 p-5 bg-cream/30"
              >
                <span className="text-ink font-serif text-lg font-semibold">
                  {market.country}
                </span>
                <p className="mt-1.5 text-ink/60 text-[15px] leading-snug">
                  {market.line}
                </p>
              </div>
            ))}
          </div>

          <p className="mt-6 text-ink/60 text-sm">
            References available on request.
          </p>
        </div>
      </div>
    </section>
  );
}